import { Center, Html } from "@react-three/drei";

export default function AboutMe() {
  return (
    <>
      <Center>
        <Html>
          <div className="aboutme">
            <h1>THIS IS THE ABOUT ME COMPONENT</h1>
          </div>
        </Html>
      </Center>
    </>
  );
}
